import { ANALYTICS_EVENTS } from '../../events'
import createAnalyticsStatic, { EventProps } from '../createAnalyticsEvent'

export interface EtfCardSelectedProps extends EventProps {
    security_code?: string
    change_in_price_ytd?: number
    positive_screens?: number
    negative_screens?: number
}

/**
 * @event etf_card_selected
 * @description Emitted when an ETF card is selected.
 */
export const EtfCardSelectedAnalytics = createAnalyticsStatic<EtfCardSelectedProps>(
    ANALYTICS_EVENTS.FIND_STOCKS.ETF_CARD_SELECTED,
)

export default EtfCardSelectedAnalytics
